<template>
  <div id="info">
    <div class="nr">
      <div class="center">
        <CompMarquee />
        <div class="ctnr">
          <h2>基本資料</h2>
          <div class="bg">
            <el-row type="flex" justify="between">
              <h3>Hi , {{ userInfo.name }} ({{ userInfo.lv }})</h3>
              <h3 style="color: #409eff; border-bottom: none">
                EXP&nbsp;:&nbsp;{{ userInfo.empiric }} /
                {{ userInfo.totalnowempiric }}
              </h3>
            </el-row>

            <!-- <el-row class="mt-2">
              <el-col :span="13">
                <h3 style="color: #409eff; border-bottom: none">
                  EXP&nbsp;:&nbsp;{{ userInfo.empiric }} /
                  {{ userInfo.totalnowempiric }}
                </h3>
              </el-col>
              <el-col :span="11">
                <el-progress
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="
                    parseInt(
                      ((userInfo.empiric * 1) /
                        (userInfo.totalnowempiric * 1)) *
                        100
                    )
                  "
                ></el-progress>
              </el-col>
            </el-row> -->
            <div class="list" v-if="!webMode">
              <p>
                分享串連網址:
                <input
                  type="text"
                  class="iptShareLink"
                  v-model="shareLink"
                  readonly
                />
              </p>
              <p>
                <button class="btn" v-on:click="vodCopy">複製分享網址</button>
                <ShareNetwork
                  network="facebook"
                  :url="shareLink"
                  :title="`${seoSettings.name} ${seoSettings.title}`"
                  :quote="`${seoSettings.name} ${seoSettings.fb_title} \n ${seoSettings.description}`"
                  :hashtags="`${seoSettings.name}`"
                  :popup="{ width: 600, height: 600 }"
                >
                  <img
                    class="share-img"
                    src="@/assets/img/fbShare.png"
                    alt=""
                  />
                </ShareNetwork>
                <ShareNetwork
                  network="line"
                  :url="shareLink"
                  :title="`${seoSettings.name} ${seoSettings.title} \n ${seoSettings.description}`"
                  :hashtags="`${seoSettings.name} ${seoSettings.keywords}`"                  
                  :popup="{ width: 600, height: 600 }"
                >
                  <img
                    class="share-img"
                    src="@/assets/img/lineShare.png"
                    alt=""
                  />
                </ShareNetwork>
              </p>
              <p>
                推薦註冊人數:&nbsp;{{ userInfo.share_reg }}&nbsp;
                <span class="ml-2"
                  >每位贈送:&nbsp;{{ userInfo.reg_bonus }}</span
                >
              </p>
              <p>
                <span>已提領:{{ userInfo.bonus1_c }}筆</span>
                <span class="ml-2">分享流量: {{ userInfo.share_view }}</span>
              </p>
              <p>
                <button
                  v-if="bolSending == false"
                  class="btn w-100"
                  v-on:click="bonusPickup(1)"
                >
                  提領
                </button>
              </p>
              <p>推薦會員儲值分潤</p>
              <p>
                <span
                  >未領取數量:{{
                    userInfo.bonus7_d_no | cleanDotFilter
                  }}希望幣</span
                >
                <span class="ml-2"
                  >已領取數量:{{
                    userInfo.bonus7_d | cleanDotFilter
                  }}希望幣</span
                >
              </p>
              <p>
                <button
                  v-if="bolSending == false"
                  class="btn w-100"
                  v-on:click="bonusPickup(7)"
                >
                  提領
                </button>
              </p>
            </div>
            <dl>
              <dd class="w250">註冊時間: {{ userInfo.created_at }}</dd>
              <dd>登入次數: {{ userInfo.login_time }}</dd>
              <dd>購買次數: {{ userInfo.order }}</dd>
            </dl>
            <div class="list">
              <h4>會員帳號</h4>
              <div class="ipt-ct">
                <input type="text" v-model="userInfo.username" disabled />
              </div>
              <h4>會員暱稱</h4>
              <div class="ipt-ct">
                <input type="text" :value="data.name" disabled />
              </div>
              <h4>會員密碼:</h4>
              <InputPassword
                :keyy="'password'"
                :data="data"
                :dataDisState="dataDisState"
                @vodEdit="vodEdit"
                @vodSave="vodSave"
              />
              <h4>電子信箱:</h4>
              <InputText
                :keyy="'email'"
                :data="data"
                :dataDisState="dataDisState"
                @vodEdit="vodEdit"
                @vodSave="vodSave"
              />
              <h4>會員性別:</h4>
              <InputRadio
                :keyy="'gender'"
                :data="data"
                :dataDisState="dataDisState"
                @vodEdit="vodEdit"
                @vodSave="vodSave"
              />
              <h4>通訊地址:</h4>
              <InputText
                :keyy="'address'"
                :data="data"
                :dataDisState="dataDisState"
                @vodEdit="vodEdit"
                @vodSave="vodSave"
              />
              <h4>Line 帳號:</h4>
              <InputText
                :keyy="'line_id'"
                :data="data"
                :dataDisState="dataDisState"
                @vodEdit="vodEdit"
                @vodSave="vodSave"
              />
              <h4>微信帳號:</h4>
              <InputText
                :keyy="'wx_id'"
                :data="data"
                :dataDisState="dataDisState"
                @vodEdit="vodEdit"
                @vodSave="vodSave"
              />

              <!-- <p>
                分享註冊人數: {{ objAccInfo.int_share_reg }} , 每筆贈送:
                {{ app.objMisc.objWG.objMemShare.intVal }}
                {{ app.strCoinName(app.objMisc.objWG.objMemShare.intCoin) }}
                <br />已提領: {{ objAccInfo.int_share_take }}筆<br /><button
                  v-if="bolSending == false"
                  class="btn"
                  v-on:click="vodTakeShare()"
                >
                  提領
                </button>
              </p>
              <p>分享流量: {{ objAccInfo.int_share_view }}</p>
              <p>
                分享串連網址: <input type="text" v-model="shareUrl" />
                <button class="btn" @click="vodCopy">複製分享網址</button
                ><a
                  class="fx"
                  style="background-color: none"
                  target="_blank"
                  :href="
                    'https://www.facebook.com/sharer/sharer.php?u=' +
                    fbShareUrl +
                    '&amp;src=sdkpreparse'
                  "
                ></a>
              </p> -->
            </div>
          </div>
        </div>
      </div>
      <CompFoot />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    CompMarquee: require("@/components/parts/Marquee").default,
    CompFoot: require("@/components/parts/Foot").default,
    CompMenNavmem: require("@/components/parts/Navmem").default,
    InputText: require("@/components/memberInfo/form/InputText").default,
    InputPassword: require("@/components/memberInfo/form/InputPassword")
      .default,
    InputRadio: require("@/components/memberInfo/form/InputRadio").default,
  },
  computed: {
    ...mapGetters({
      webMode: "webMode",
    }),
    ...mapState({
      userInfo: (state) => state.member.userInfo,
      seoSettings: (state) => state.website.seoSettings,
    }),
    shareLink() {
      const shareLink = `${location.origin}/#/home/${this.userInfo.link}`;
      return shareLink;
    },
  },
  data() {
    return {
      data: {},
      dataDisState: {},
      //
      strPop: "",
      bolSending: false,
      fbShareUrl: "https://mapi.3cezgo.com/member/fbShare",
      shareUrl: "",
    };
  },
  methods: {
    async getuser() {
      await this.$store.dispatch("member/getuser");
      this.handleEditFrom();
    },
    async handleEditFrom() {
      let _data = Object.assign({}, this.userInfo);
      this.data = {
        name: _data.name,
        password: _data.password,
        email: _data.email,
        gender: _data.gender,
        address: _data.address,
        line_id: _data.line_id,
        wx_id: _data.wx_id,
      };
      let dataDisState = {};
      await Object.keys(this.data).forEach((x) => {
        dataDisState[x] = false;
      });
      this.dataDisState = dataDisState;
    },
    async vodEdit(str) {
      this.dataDisState[str] = true;
      await this.$bus.emit("input.blur" + str, str);
      await this.$bus.emit("input.focus" + str, str);
    },
    async vodSave(str) {
      if (!this.data[str]) {
        this.$root.$snotify.error("未輸入任何資料");
        return;
      }
      let _d = {};
      _d[str] = this.data[str];
      const state = await this.$store.dispatch("member/edituser", _d);
      if (state) {
        this.dataDisState[str] = false;
        this.$bus.emit("input.blur" + str, str);
        this.getuser();
      }
    },
    //
    vodCopy() {
      let ipt = document.getElementsByClassName("iptShareLink");
      ipt[0].select();
      document.execCommand("copy");
      this.$root.$snotify.success("分享網址已複製", "複製成功");
    },
    async bonusPickup(type) {
      const data = {
        token: sessionStorage.token,
        type,
      };
      await this.$store.dispatch("bonus/bonusPickup", data);
      this.$store.dispatch("member/getuser");
    },
  },
  async created() {
    await this.getuser();
  },
};
</script>
<style>
@import "~@/assets/css/info.css";
.mt-2 {
  margin-top: 0.2rem;
}
.ml-2 {
  margin-left: 0.2rem;
}
.share-img {
  height: 0.76rem;
  vertical-align: bottom;
  margin-left: 0.2rem;
}
.w-100 {
  width: 100% !important;
}
/* height: 38px;
    line-height: 38px;
    text-align: center;
    padding: 0 15px;
    background: #792b93;
    font-size: 17px;
    color: #fff;
    margin-top: .2rem;
    width: 4rem;
    float: left; */
</style>
